import { render } from "./HeaderMenu.vue?vue&type=template&id=0a5328ca&scoped=true"
import script from "./HeaderMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&lang=js"

import "./HeaderMenu.vue?vue&type=style&index=0&id=0a5328ca&scoped=true&lang=scss"

import exportComponent from "/usr/share/node/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5328ca"]])

export default __exports__